import { useRef } from "react";
import { SocketEventTypes, SocketMessage } from "../responses";
import { LiveValueListener } from "@components/Context/SocketContext";

// export type MessageListener = (event: MinerBaseEvent) => void;
type TypeListeners = Record<number, LiveValueListener[]>;

interface IMessageListeners {

  addMessageListener: (
    type: SocketEventTypes,
    listener: LiveValueListener
  ) => void;

  removeMessageListener: (
    type: SocketEventTypes,
    listener: LiveValueListener
  ) => void;

  processMessage: (
    message: SocketMessage<any>
  ) => void;

}

export function useMessageListeners(): IMessageListeners {

  const listenersRef = useRef<TypeListeners>({});

  function addMessageListener(
    type: SocketEventTypes,
    listener: LiveValueListener
  ) {
    const listeners = listenersRef.current[type];
    if (listeners) {
      if (listeners.indexOf(listener) === -1) {
        listeners.push(listener);
      }
    } else {
      listenersRef.current[type] = []
      listenersRef.current[type].push(listener);
    }
  }

  function removeMessageListener(
    type: SocketEventTypes,
    listener: LiveValueListener
  ) {
    const listeners = listenersRef.current[type];
    if (listeners) {
      const idx = listeners.indexOf(listener);
      if (idx > -1) {
        listeners.splice(idx, 1);
      }
    }
  }

  function processMessage(
    message: SocketMessage<any>
  ) {
    if (message.type !== undefined) {
      const listeners = listenersRef.current[message.type];
      if (listeners && listeners.length > 0) {
        listeners.forEach(listener => {
          listener(message);
        });
      }
    }
  }

  return {
    addMessageListener,
    removeMessageListener,
    processMessage
  }
}